import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { DatosServiciosGestion } from "../DatosServiciosGestion/DatosServiciosGestion";

export const ACTAgregarReporte: EntityClientAction = {
    name: 'ACTAgregarReporte',
    label: 'Editar Reporte',
    title: <Text fw={700}>Editar Reporte</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportes',
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const datosServiciosGestion = new DatosServiciosGestion(entity.API.client);
        datosServiciosGestion.def.columns.c_visita_id.value = selectedKeys![0].c_visita_id as unknown as string || '';

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: datosServiciosGestion,
                initialFormMode: 'view',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
        });

        return false;
    }
}